import { motion } from "framer-motion";
import { ArrowUp, ArrowUpRight } from "lucide-react";
import { EMAIL, INSTAGRAM } from "../data/site";
import { getLenis } from "../lib/lenis";

const EASE = [0.16, 1, 0.3, 1];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-black border-t border-[#222]">
    <div
      className="px-4 md:px-10 py-24 md:py-36"
      style={{
        backgroundImage: "linear-gradient(rgba(0,0,0,0.9), rgba(0,0,0,0.82)), url(/media/khush-portrait.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="font-jetmono text-[10px] tracking-[0.35em] uppercase text-[#808080] mb-8"
      >
        04 / CONTACT
      </motion.p>

      <h2 data-testid="contact-heading" className="font-syncopate font-bold uppercase leading-[1.02] tracking-tight text-[11vw] sm:text-[9vw] lg:text-[7.5vw] mb-12 md:mb-16">
        <motion.span
          className="block"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          transition={{ staggerChildren: 0.12 }}
        >
          {["READY WHEN", "YOU ARE."].map((line) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                variants={{ hidden: { y: "115%" }, show: { y: 0 } }}
                transition={{ duration: 1, ease: EASE }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </motion.span>
      </h2>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
        className="flex flex-col md:flex-row md:items-center gap-6 md:gap-12"
      >
        <a
          data-testid="contact-email-link"
          href={`mailto:${EMAIL}`}
          className="group inline-flex items-center gap-4 border border-white px-6 md:px-10 py-4 md:py-6 font-syncopate font-bold uppercase tracking-tight text-[13px] sm:text-2xl md:text-3xl break-all hover:bg-white hover:text-black transition-colors duration-500"
        >
          {EMAIL}
          <ArrowUpRight className="group-hover:rotate-45 transition-transform duration-500" size={26} />
        </a>
        <a
          data-testid="contact-instagram-link"
          href={INSTAGRAM}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 font-jetmono text-xs tracking-[0.25em] uppercase text-[#808080] hover:text-white transition-colors duration-300"
        >
          INSTAGRAM — @KHUSHPATELPHOTOGRAPHY
          <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-500" />
        </a>
      </motion.div>
    </div>

    <footer className="border-t border-[#222] px-4 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-jetmono text-[10px] tracking-[0.2em] uppercase text-[#808080]">
      <span>© {new Date().getFullYear()} KHUSH PATEL PHOTOGRAPHY</span>
      <span>LOS ANGELES, CA — 34.0522° N, 118.2437° W</span>
      <button
        data-testid="back-to-top-btn"
        onClick={() => (getLenis() ? getLenis().scrollTo(0, { duration: 1.6 }) : window.scrollTo({ top: 0, behavior: "smooth" }))}
        className="flex items-center gap-2 hover:text-white transition-colors duration-300"
      >
        BACK TO TOP <ArrowUp size={14} />
      </button>
    </footer>
  </section>
);
